export var objectIdGenerationState = {
    uniqueIdCounter: 0,
    primaryObjectIdGenerator: null,
};
//# sourceMappingURL=objectIdGenerationState.js.map